module.exports = {
      id: "tomato-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#tomato",
      toString: function () {
        return this.url;
      }
    }